module.exports = __webpack_public_path__ + "static/SiteOrigin-13e969033ec18fffdfe7fe3378251364.svg";